import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

import type {
  OfferContentByChunkResponse,
  OfferContentGeneratorRequest,
} from './offer-content-generator.types';

@Injectable({
  providedIn: 'root',
})
export class EventStreamService {
  private readonly httpApiService = inject(HttpApiService);

  public send<TDataResponse>(
    method: 'POST' | 'PATCH',
    url: string,
    body: OfferContentGeneratorRequest,
    {
      headers: customHeaders,
      attachRtDefaultHeaders,
    }: { headers: Record<string, string>; attachRtDefaultHeaders: boolean } = {
      headers: {},
      attachRtDefaultHeaders: true,
    },
  ): Observable<OfferContentByChunkResponse<TDataResponse>> {
    return new Observable(sub => {
      const xmlHttpRequest: XMLHttpRequest = new XMLHttpRequest();

      xmlHttpRequest.addEventListener('progress', () =>
        sub.next({ type: 'progress', message: xmlHttpRequest.response }),
      );
      xmlHttpRequest.addEventListener('load', () => {
        sub.next({ type: 'load', message: xmlHttpRequest.response });
        sub.complete();
      });
      xmlHttpRequest.addEventListener('error', () => sub.error(xmlHttpRequest.responseText));
      xmlHttpRequest.addEventListener('abort', () => sub.error(xmlHttpRequest.responseText));

      xmlHttpRequest.open(method, url);
      const headers = {
        ...customHeaders,
        ...(attachRtDefaultHeaders ? this.httpApiService.getDefaultHeaders() : {}),
        ...{ 'Content-Type': 'application/json;charset=UTF-8' },
      };
      this.processHeaders(xmlHttpRequest, headers);
      xmlHttpRequest.send(JSON.stringify(body));

      return () => {
        xmlHttpRequest.abort();
      };
    });
  }

  private processHeaders(xmlHttpRequest: XMLHttpRequest, headers: Record<string, string>): void {
    Object.entries(headers).forEach(([key, value]) => {
      xmlHttpRequest.setRequestHeader(key, value);
    });
  }
}
